import React, { useEffect } from 'react';
import SEO from '@/components/SEO';

export default function PrivacyPage() {
    return (
        <>
            <SEO title="Politika privatnosti | Škobić Keramika" noindex />
            <div className="sk-section">
                <div className="sk-container max-w-3xl sk-prose">
                    <h1 className="font-display text-4xl mb-4">Politika privatnosti</h1>
                    <p>Ova stranica je u pripremi. Škobić Keramika štiti privatnost svojih posjetitelja i klijenata.</p>
                    <h2>Prikupljanje podataka</h2>
                    <p>Prikupljamo isključivo podatke koje korisnik dobrovoljno unese kroz kontakt formu (ime, email, telefon, poruka). Podaci se koriste isključivo za odgovor na upit i ne dijele se s trećim stranama.</p>
                    <h2>Kontakt</h2>
                    <p>Za sva pitanja o privatnosti: <a href="mailto:skobickeramika@gmail.com">skobickeramika@gmail.com</a></p>
                </div>
            </div>
        </>
    );
}
